import { motion } from 'framer-motion';
import CreateAccountForm from './CreateAccountForm';
import { useAssessmentContext } from '../../../providers/AssessmentContext';

function SaveApneaAssessment() {
    const { answers, isCoachingPath } = useAssessmentContext();

    const hasValidPriorStudy =
        answers.previouslyDiagnosedWithSleepApnea &&
        answers.hasPriorStudy &&
        answers.howBroughtToGem !== 'NEED_NEW_SLEEP_TEST' &&
        !answers.gained20Lbs;

    return (
        <>
            <motion.div
                initial={{ opacity: 0, translateX: '20%' }}
                animate={{ opacity: 1, translateX: 0 }}
                exit={{ opacity: 0, translateX: '-20%' }}
                transition={{ ease: [0.5, 1, 0.89, 1] }}
                className="lg:flex">
                <div className="lg:w-2/5">
                    <h2 className="mb-4 font-heading text-5xl lg:mb-5 lg:mt-14 lg:text-[80px]">
                        {hasValidPriorStudy || isCoachingPath
                            ? 'SET UP YOUR GEM SLEEP PROFILE.'
                            : "LET'S GET YOU THE HOME SLEEP STUDY."}
                    </h2>
                    <p className="mb-14 text-lg font-bold lg:mb-0  lg:text-2xl">
                        {hasValidPriorStudy && !isCoachingPath
                            ? 'After account creation you will be asked to upload a copy of your current sleep study.'
                            : 'The first step is to create a GEM account. '}
                    </p>
                </div>

                <div className="border-8 border-purple-medium border-opacity-20 p-8 lg:ml-16 lg:w-3/5 lg:p-14">
                    <CreateAccountForm />
                </div>
            </motion.div>
        </>
    );
}

export default SaveApneaAssessment;
